import { Component } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { validator } from 'Helpers/validator';
import validation from 'Helpers/Validation';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { isNumber } from 'Helpers';

class AddUser extends Component {
    constructor(props){
        super(props);
        this.state={
            fields:{
                countryCode:'91',
                mobileNumber:''
            },
        }
        this.validator = validator.getInstance();
    }

    /**
     * @method validation
     * @summary validate the inputs based on validation rules
     * @param {event} event - React onBlur event
     * @return {none} undefined
     */
    
    validation = e => {
        validation(e, 'app-access-control-add-user-form');
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { id } = event.target;
        const { fields } = this.state;

        if (id && !this.validator.checkBeforeSubmit(id)) {
            this.props.appAccessControlAddUserAction(fields, this.props.filteredWithSort);
        }
    }

    handleChange = event => {
        const { name, value } = event.target;
        const fields = { ...this.state.fields };
        fields[ name ] = value;
        this.setState({ fields });
    };

    componentDidUpdate(prevProps){
        if(prevProps.appAccessControlAddUser.loading && !this.props.appAccessControlAddUser.loading && !this.props.appAccessControlAddUser.error){
            this.props.toggleAddUserPopup(false);
        }
    }

    render(){
        const { toggleAddUserPopup, appAccessControlAddUser } = this.props;
        const { fields } = this.state;
        return(
        <div className={ `addadmin` } id='appAccessControlAddUser'>
            <div className='overlay' onClick={ () => toggleAddUserPopup() }></div>
            <div className='addmgnt'>
                <LoadingOverlay
                    active={ appAccessControlAddUser.loading }
                    spinner
                    styles={ {
                    wrapper: {
                        width: '100%',
                        textAlign: '-webkit-center'
                    }
                    } }
                    text='Please wait...'
                ></LoadingOverlay>
                <div className='head'>
                    <h2>Add User</h2>
                </div>
                <form id='app-access-control-add-user-form' autoComplete='off' onSubmit={ this.handleSubmit }>
                <div className='ctInputCountryField'>
                    <label>
                        Mobile Number<sup>*</sup>
                    </label>
                    <div className="wrap-form-control country-phone">
                        
                        <PhoneInput
                            searchPlaceholder='Search'
                            country={ 'in' }
                            name='countryCode'
                            value={ fields.countryCode }
                            enableSearch={ true }
                            disableSearchIcon={ true }
                            onChange={ (value)=> this.handleChange({ target:{ name:'countryCode', value } }) }
                        />
                        <input
                            type='text'
                            name='mobileNumber'
                            value={ fields.mobileNumber }
                            maxLength='25'
                            data-validation={ [ 'mobilenumber' ] }
                            placeholder='Enter Mobile Number here!'
                            onBlur={ this.validation }
                            onChange={ (evt) => {
                                if(!isNumber(evt.target.value)) return;
                                this.handleChange(evt)
                            } }
                            data-mainparent={ true }
                        />
                    </div>
                </div>
                <div className='buttons'>
                    <div>
                        <button
                            type='reset'
                            onClick={ () => toggleAddUserPopup() }
                            className='btn btn_outline'
                        >
                            Cancel
                        </button>
                        <button type='submit' className='btn btn_primary'>
                            Save
                        </button>
                    </div>
                </div>
                </form>
            </div>
        </div>
        )
    }
}

export default AddUser;